import { Stack } from '@mui/material';
import { DBKanbanThunks, kanbanSelectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import BTCheckboxList from "../checkbox-list/bt-checkbox-list";
import { getDynamicColumnListForBTCheckbox } from '@common-reducers/TaskSelectors';
import { TaskColumn } from '@common-models/task-column';

export default function KanbanColumnPicker() {
    const dispatch = useAppDispatch()
    const currentBoardView = useAppSelector((state) => state.TasksReducer.currentBoardView)
    const [kanban] = useAppSelector((state) => kanbanSelectByQuery(state.DBKanbanReducer, { _id: currentBoardView.id }, ['includedColumns']));
    const columnList = useAppSelector((state) => getDynamicColumnListForBTCheckbox(state, 'kanban'))



    const handleCheckBoxChange = (value: boolean, column: TaskColumn) => {
        const colKey = column._id ?? '';
        dispatch(
            DBKanbanThunks.patch({
                entity: {
                    _id: currentBoardView.id,
                    includedColumns: {
                        ...kanban?.includedColumns,
                        [colKey]: value,
                    }
                }
            })
        )
    }

    function handleAllCheckBoxChange(value: boolean) {
        const newIncludedColumnsList = columnList.map((column) => ({
            id: column._id, boolean: value
        }))
        let newIncludedColumns: Record<string, boolean> = {}
        for (let i in newIncludedColumnsList) {
            const entry = newIncludedColumnsList[i];
            if (entry.id) {
                newIncludedColumns = {
                    ...newIncludedColumns,
                    [entry.id]: entry.boolean
                }
            }
        }

        dispatch(
            DBKanbanThunks.patch({
                entity: {
                    _id: currentBoardView.id,
                    includedColumns: newIncludedColumns
                }
            })
        )
    }


    const isChecked = (column: TaskColumn) => {
        const colKey = column._id ?? '';
        if (kanban?.includedColumns) {
            return (kanban?.includedColumns[colKey] ?? false)
        }
        else {
            return false
        }
    }

    const isCheckedRecord: Record<string, boolean> = columnList.reduce<Record<string, boolean>>((isCheckedRecord, column) => ({
        ...isCheckedRecord,
        [column._id ?? '']: isChecked(column)
    }), {});


    return (
        <Stack direction="column" >
            <BTCheckboxList
                isCheckedRecord={isCheckedRecord}
                columnList={columnList}
                handleCheckBoxChange={handleCheckBoxChange}
                handleAllCheckBoxChange={handleAllCheckBoxChange}
            />
        </Stack>
    )
}   